// extracted by mini-css-extract-plugin
module.exports = {"checkboxWrapper":"footer-subscription_checkboxWrapper__j9WN3"};